module.exports = __webpack_public_path__ + "img/432e909.png";